import { useState } from 'react';
import { useBreakpoints } from '@monorepo/nova-ui';
import { type OptionalAssets } from '@monorepo/types';
import { type CreditCartAsset } from '../credit-events.types';
import { StyledPrimaryCreditButton } from '../styled';
import RedeemCreditsTooltip from './redeem-credits-tooltip';
import RedeemCreditsTooltipMobile from './redeem-credits-tooltip-mobile';

interface RedeemCreditButtonProps {
  redeemLabel: string;
  cartAssets?: CreditCartAsset[];
  onRedeem: () => void;
  onRedeemForAsset?: (asset: OptionalAssets) => void;
  onNewOrder?: () => void;
}

const RedeemCreditButton = ({
  redeemLabel,
  cartAssets,
  onRedeem,
  onRedeemForAsset,
  onNewOrder,
}: RedeemCreditButtonProps) => {
  const { isMobile } = useBreakpoints();
  const [selectorOpen, setSelectorOpen] = useState(false);

  const hasMultipleAssets = Boolean(cartAssets && cartAssets.length > 1);

  const handleRedeemClick = () => {
    if (hasMultipleAssets) {
      setSelectorOpen((prev) => !prev);
      return;
    }
    onRedeem();
  };

  const handleCloseSelector = () => setSelectorOpen(false);

  const handleApply = (asset: OptionalAssets) => {
    handleCloseSelector();
    onRedeemForAsset?.(asset);
  };

  const handleNewOrderClick = () => {
    handleCloseSelector();
    onNewOrder?.();
  };

  const button = (
    <StyledPrimaryCreditButton variant="primary" onClick={handleRedeemClick}>
      {redeemLabel}
    </StyledPrimaryCreditButton>
  );

  if (isMobile) {
    return (
      <RedeemCreditsTooltipMobile
        open={selectorOpen}
        onClose={handleCloseSelector}
        cartAssets={(hasMultipleAssets && cartAssets) || undefined}
        onApply={handleApply}
        onNewOrder={handleNewOrderClick}
      >
        {button}
      </RedeemCreditsTooltipMobile>
    );
  }

  return (
    <RedeemCreditsTooltip
      open={selectorOpen}
      onClose={handleCloseSelector}
      cartAssets={(hasMultipleAssets && cartAssets) || undefined}
      onApply={handleApply}
      onNewOrder={handleNewOrderClick}
    >
      {button}
    </RedeemCreditsTooltip>
  );
};

export default RedeemCreditButton;
